import ErrorBoundary from '@/components/ErrorBoundary';
import { ClassNameProvider } from '@/styles/ElementTag';
import { DefaultComponent, StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { standaloneComponent } from 'modules/dynamic-components';
import { ReactNode } from 'react';
import { StandaloneOptionalLinkProps } from '../OptionalLink';
import { Tag, TagProps } from './Tag';

const OptionalLink = standaloneComponent<StandaloneOptionalLinkProps>('ElementOptionalLink');

export interface StandaloneTagProps extends StandaloneComponentProps {
  value?: ReactNode;
  link?: StandaloneOptionalLinkProps;
  options?: TagProps;
}

export const StandaloneTag: StandaloneComponent<StandaloneTagProps> = ({ value, link, options, ...props }) => {
  const $base = options || {};
  return (
    <ErrorBoundary>
      <ClassNameProvider value={$base}>
        <OptionalLink
          content={
            <Tag {...$base} {...props}>
              {value}
            </Tag>
          }
          {...link}
        />
      </ClassNameProvider>
    </ErrorBoundary>
  );
};

export const standalone = StandaloneTag;

const DefaultTag: DefaultComponent = () => <StandaloneTag />;

export default DefaultTag;
